<template>
  <div class="addContactsContainer">
    <div class="title" v-if="mode!=='view'">
      <a-button type="primary" icon="plus" @click="handleAdd" >
        添加联系人
      </a-button>
    </div>
    <div class="list">
      <a-table :columns="columns" :data-source="data" :pagination="false">
        <template
          v-for="col in ['name', 'position', 'phone1','email','remark']"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.key, col)"
            />
            <template v-else>
              {{ record[col] }}
            </template>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record" v-if="mode!=='view'">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => save(record.key)">保存</a>
              <a-divider type="vertical" />
              <a @click="() => cancel(record.key)">取消</a>
            </span>
            <span v-else>
              <a :disabled="editingKey !== ''" @click="() => edit(record.key)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDel(record.key)">
                <a :disabled="editingKey !== ''">删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>

const columns = [
  {
    title: '联系人姓名',
    dataIndex: 'name',
    width: '15%',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '职位',
    dataIndex: 'position',
    width: '15%',
    scopedSlots: { customRender: 'position' }
  },
  {
    title: '联系电话',
    dataIndex: 'phone1',
    width: '15%',
    scopedSlots: { customRender: 'phone1' }
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    width: '20%',
    scopedSlots: { customRender: 'email' }
  },
  {
    title: '备注',
    dataIndex: 'remark',
    width: '10%',
    scopedSlots: { customRender: 'remark' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]
const data = []
export default {
  name: 'AddContacts',
  props: {

  },
  components: {},
  watch: {
    cacheData: {
      handler (data) {
        console.log('change', data)
      },
      immediate: true
    }
  },
  data () {
    // this.cacheData = data.map(item => ({ ...item }))
    return {
      mode: 'add',
      data,
      cacheData: [],
      columns,
      editingKey: '',
      checkKey: ['name']
    }
  },
  methods: {
    // 设置mode类型
    setMode (type) {
      this.mode = type
    },
    // 验证联系人的信息填写是否完整
    validate () {
      let flag = true
      let dataObj = null
      for (let i = 0; i < this.data.length; i++) {
        dataObj = this.data[i]
        for (const key in dataObj) {
          if (this.checkKey.indexOf(key) >= 0 && !dataObj[key]) {
            flag = false
            // this.$message.warning('请填写完整后提交！')
            console.log('key:', key)
            break
          }
        }
      }
      return flag
    },
    // 获取新增的数据
    getDataList () {
      return this.data
    },
    // 设置数据
    setDataList (datalist) {
      this.data = []
      this.cacheData = []

      this.$nextTick(() => {
        for (let i = 0; i < datalist.length; i++) {
          if (!datalist.key) {
            datalist[i].key = i
          }
          this.data.push(datalist[i])
          this.cacheData.push(datalist[i])
        }
      })
    },
    // 清除数据
    clearData () {
      this.data = []
      this.cacheData = []
    },
    // 添加
    handleAdd () {
      const index = this.data.length
      this.data.push({
        key: index,
        name: '',
        position: '',
        phone1: '',
        email: '',
        remark: '',
        editable: true
      })
      this.editingKey = index.toString()
    },
    handleChange (value, key, column) {
      const newData = [...this.data]
      const targetModel = newData.filter(item => key === item.key)[0]
      if (targetModel) {
        targetModel[column] = value
        // this.data = newData
      }
      console.log(this.cacheData)
    },
    edit (key) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      this.editingKey = key
      if (target) {
        target.editable = true
        this.data = newData
      }
    },
    handleDel (key) {
      const newData = [...this.data].filter(item => item.key !== key)
      for (let i = 0; i < newData.length; i++) {
        newData[i].key = i
      }
      this.data = newData
      this.cacheData = this.data
    },
    save (key) {
      const newData = [...this.data]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        delete target.editable
        this.data = newData
        this.cacheData = this.data
      }
      this.editingKey = ''
    },
    cancel (key) {
      const newData = [...this.data]
      const target = this.data.filter(item => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
        delete target.editable
        this.data = newData.filter((item) => {
          return item.key != key
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
  .addContactsContainer {
    .title {
      margin-bottom: 10px;
    }
    .list{
      margin-bottom: 10px;
    }
  }
</style>
